import React, { useContext, useEffect } from 'react';
import LogoContainer from '../../components/header/LogoContainer';

import { useLocation, useNavigate } from 'react-router-dom';
const Feedbacks = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { providerId } = window;
  const firstName = params.get("firstName");
  const lastName = params.get("lastName");
  const today = new Date();
  const month = today.getMonth() + 1; 
  const day = today.getDate();
  const year = today.getFullYear();
  
    const navigate = useNavigate();
    let jotformId = window.buildfireID == 'D' ? '69ccff823965360c43c81a0394fd': '69cd007635373367335d95f3a317';

  const feedbackUrl = `https://form.jotform.com/260903082887161/prefill/${jotformId}?name[first]=${firstName}&name[last]=${lastName}&date[month]=${month}&date[day]=${day}&date[year]=${year}&userID=${providerId}`;
  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data && data.action === 'submission-completed') {
        setTimeout(() => {
          navigate(-1)
        }, 2000);
      }
    });
  }, []);

  return (
    <div style={{ height: '100%' }}>
      <LogoContainer title="Feedbacks" />
      <iframe
        title="Feedbacks"
        style={{ width: '100%', height: '100%' }}
        src={feedbackUrl}
        id="iframe_id"
        frameBorder="0"
        allowFullScreen />
    </div>

  );
};

export default Feedbacks;
